import { createFileRoute } from "@tanstack/react-router";
import { AgentGuardrailsIndexRoute } from "@/components/agents/agent-guardrails-route";

export const Route = createFileRoute("/$owner/agents/$agentId/guardrails/")({
	component: AgentGuardrailsIndexPage,
});

function AgentGuardrailsIndexPage() {
	const { owner, agentId } = Route.useParams();
	return <AgentGuardrailsIndexRoute owner={owner} agentId={agentId} />;
}
